exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forgot[data-v-32de3b4d]{float:right}", ""]);

// exports
